<template>
    <div class="homeDiv">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/image/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <!--搜尋-->
        <div class="MessageSearch my-3">
            <form class="form-inline my-2 my-lg-0 ml-auto MessageSearchForm">
                <input class="form-control mr-sm-2 searchText" type="search" placeholder="User ID" aria-label="Search" v-model="SearchUserId"
                    @keydown.enter.exact.prevent="SearchMsg()" >
                <button class="MessageSearchIcon" type="button" @click="SearchMsg()" ><i class="fas fa-search"></i></button>
            </form>
        </div>
        <!--訊息-->
        <div>
            <div class="d-flex justify-content-around homeBtnBar">
                <div class="HomeBtn">
                    <span class="active" id="Mes" @click="ShowMesCon(true)" >歷史訊息</span>
                </div>
                <div class="HomeBtn">
                    <span class="" id="Con" @click="ShowMesCon(false)">聯絡我們</span>
                </div>
            </div>
            <!--歷史訊息-->
            <div v-if="ShowMessage">
                <Message :msgHistoryObjects="msgHistoryObjects"></Message>
            </div>
            <!--聯絡我們-->
            <div v-if="!ShowMessage">
                <Contact :contactObjects="contactObjects"></Contact>
            </div>
        </div>
    </div>
</template>

<script>
import Contact from '@/components/Pages/Contact'
import Message from '@/components/Pages/Message'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'Home',
    components:{
        Contact,Message
    },
    data () {
        return {
            ShowMessage:true,
            Token:'',
            UserId:'',
            // username:'',
            // pwd:'',
            msgHistoryObjects:[],
            contactObjects:[],
            SearchUserId:'',
            timeout:0,
            showLoading:false,
        }
    },
    methods:{
        SearchMsg(){
            if(this.SearchUserId != ''){
                var data={
                    MsgType: 1,                
                    msgHistory: {
                        UserId: this.SearchUserId,
                        UserName: '',
                    }
                }

                this.$router.push({
                    name: 'Chat',
                    params: { 
                        msgObjects:data,
                    }
                });

                this.SearchUserId = ''
            }
        },
        GetMessageList(){
            this.showLoading = true;

            //Axios
            const headers = {"Authorization": 'Bearer '+this.Token};
            const api =`${process.env.APIPATH}/api/LiveChat/GetMessageList`;

            axios.post(api, {}, { headers })
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.IsSuccess){ //成功
                        this.msgHistoryObjects = response.data.msgHistoryObjects;
                        this.contactObjects = response.data.contactObjects;
                    }else{
                        alert("獲取聊天紀錄失敗：" + response.data.Message);
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        // 歷史訊息/聯絡我們 切換
        ShowMesCon(ShowMessage){
            this.ShowMessage = ShowMessage;
            if(ShowMessage){ //歷史訊息
                document.querySelector('#Mes').classList.add('active');
                document.querySelector('#Con').classList.remove('active');
            }else{ //聯絡我們
                document.querySelector('#Mes').classList.remove('active');
                document.querySelector('#Con').classList.add('active');
            }
        },
        // getToken(){
        //     //Axios
        //     // this.username = 'hineetest99@hineetest.com';
        //     // this.pwd = '654321';

        //     // const api =`https://teststudentcenterapi.hitute.com/api/Login/GetToken`;
        //     const api =`${process.env.APIPATH}/api/Login/GetToken`;
        //     var data={}
        //     axios.post(api, data, { auth: {username: this.username, password: this.pwd} })
        //     .then((response) => {
        //             // console.log("get token")
        //             sessionStorage.setItem('Token',response.data.Token);
        //             sessionStorage.setItem('UserId',response.data.UserId);
        //             this.Token = response.data.Token;
        //             this.connectWS();
        
        //             this.GetMessageList();
        //         })
        //         .catch(error => {
        //             this.errorMessage = error.message;
        //             console.error("There was an error!", error);
        //         });
        // },
        connectWS(){
            if(this.$root.$refs.ws != undefined){
                clearTimeout(this.timeout);
                if(this.$root.$refs.ws.IsConnected == false){
                    this.$root.$refs.ws.Connect();
                }
            }else{
                this.timeout = setTimeout(() => {
                    this.connectWS();
                }, 1000);
            }
        },
    },
    created(){
        var canLoadData = false;
        //直接在首頁重整哩，不跳回登入畫面。
        // if(localStorage.getItem('reload') || localStorage.getItem('Token') == undefined){            
        //     this.Token = sessionStorage.getItem('Token');
        //     localStorage.setItem('reload', false); 
        //     canLoadData = true;
        // }else
        //網址get token
        if(this.$route.query.lc_key != undefined){
            var LoginData = JSON.parse(window.atob(this.$route.query.lc_key.toString()));
            
            this.Token = LoginData.Token;
            this.UserId = LoginData.UserId;
            sessionStorage.setItem('Token',this.Token );
            sessionStorage.setItem('UserId',this.UserId );
            canLoadData = true;

        }else if(sessionStorage.getItem('Token') != undefined){
            this.Token = sessionStorage.getItem('Token');
            canLoadData = true;
        }else{
            this.$router.push({
                name: 'loginPage',
                params: {
                }
            });
        }

        if(canLoadData){
            this.connectWS();
            this.GetMessageList();
        }

        sessionStorage.setItem('WhereAmI', -1) //-1:home , other:msg room

    },
    beforeDestroy() {
    },
}
</script>




// WEBPACK FOOTER //
// src/components/Pages/Home.vue